import React from 'react';
import security from '../../../images/security.jpg';
import clean from '../../../images/clean.jpg';
import speed from '../../../images/speed.jpg';
// import './BlogInfo.css'
import BlogPageCard from '../BlogPageCard/BlogPageCard';


const allBlogData = [
    {
        title: 'Top 10 Network Security Tips from Our Experts',
        description: 'The internet has become a space riddled with malicious links...',
        author: 'Marie Jerry',
        img: security,
        date: '23 March 2021',
        search: 'computer-security-tips'
    },
    {
        title: 'How To Clean Your PC from Viruses',
        description: 'There’s nothing quite like realizing your Windows PC, Mac, or laptop...',
        author: 'Samuel Tyler',
        img: clean,
        date: '23 Jan 2020',
        search: 'computer-security-tips'
    },
    {
        title: 'How to Speed Up Your Old MacOS Laptop',
        description: 'Remember the feeling of a brand new Mac? A Mac without rainbow...',
        author: 'Albert Philip',
        img: speed,
        date: '14 April 2021',
        search: 'computer-security-tips'
    }
]

const BlogPageInfo = () => {
    return (
        <section className="blogs">
            <div className="container">
                <div className="section-header text-center mt-3">
                    <h2 className="fw-bold">Al Blogs</h2>
                    <h5 className='text-secondary'>My All Blogs Are Here</h5>
                </div>
                {/* <div className="card-deck mt-5"> */}
                <div className="row">
                    {
                        allBlogData.map(allBlog => <BlogPageCard allBlog={allBlog} key={allBlog.title} />)
                    }
                </div>
                <div className="mb-5 mt-3 d-flex justify-content-center">
                    <h4 className="fst-italic">New Blogs Are Coming Soon</h4>
                </div>
            </div>
        </section>
    );
};

export default BlogPageInfo;